import { render } from "./ShangWuContent.vue?vue&type=template&id=3fd4a828&scoped=true"
import script from "./ShangWuContent.vue?vue&type=script&lang=js"
export * from "./ShangWuContent.vue?vue&type=script&lang=js"

import "./ShangWuContent.vue?vue&type=style&index=0&id=3fd4a828&scoped=true&lang=css"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd4a828"]])

export default __exports__